/*var _customerEmail = getShoptetDataLayer('customer').email;
if (
	_customerEmail === 'marek.krivan@mimedigital.cz' ||
	_customerEmail === 'michal.valent@healthfactory.cz' ||
	_customerEmail === 'medard.huttenbach@mimedigital.cz' ||
	_customerEmail === 'slavomir.migota@mimedigital.cz '
) { */

	if (shoptet.cookie.get('init_subscription_card')) {
		shoptet.cookie.create('init_subscription_card', null, {days: -1});

		if (window.location.href.indexOf('/kosik') > -1) {
			$('body').hide();
			window.location.href = '/klient/klient-platby/?addCard';
		}
	}

	if ($('a[href*="/paymentCardDelete"]').length > 0 && window.location.href.indexOf('addCard') > -1) {
		showMessage('Karta byla úspěšně přidána', 'notice');
	}

	require('./cart/headerCart.js')
	require('./cart/step1.js')
	require('./cart/step2.js')
	require('./cart/step3.js')
	require('./cart/step4.js')
	require('./mySubscription/index')
	require('./productDetail/index')
	require('./selectAlternativeProducts')
	require('./myChildren')
	require('./myPayment')
// }